export const loading = 'loading'
export const uploader = 'uploader'
export const modalUploader = 'modalUploader'

export const btnUploader = 'btnUploader'
export const btnModalUploader = 'btnModalUploader'
